import {
  GET_OUTLET_SUMMARY_LOADING,
  GET_OUTLET_SUMMARY_SUCCESS,
  GET_OUTLET_SUMMARY_FAILD,
} from "../types";

const initialState = {
  outletData: null,
  loading: null,
  error: null,
};

export const getOutletSummaryReducer = (
  state = initialState,
  action: { type: any; loading: any; payload: any; error: any }
) => {
  switch (action.type) {
    case GET_OUTLET_SUMMARY_LOADING:
      return {
        ...state,
        loading: action.loading,
        error: null,
      };
    case GET_OUTLET_SUMMARY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        outletData: action.payload,
      };
    case GET_OUTLET_SUMMARY_FAILD:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    default:
      return state;
  }
};
